import { createSelector } from '@reduxjs/toolkit';

import type { VideoPlannerState } from './video-planner-slice';
import type { VideoDraft } from './video-planner-types';

import type { RootState } from 'js/src/libs/RootState';

export const selectVideoPlannerState = (state: RootState): VideoPlannerState => state.videoPlanner;

export const selectVideoDrafts = (state: RootState): VideoDraft[] =>
    selectVideoPlannerState(state).videoDrafts;

const selectVideoDraftsById = createSelector([selectVideoDrafts], (drafts) => {
    const map = new Map<string, VideoDraft>();
    for (const draft of drafts) {
        map.set(draft.id, draft);
    }
    return map;
});

export function getVideoDraftById(state: RootState, id: string): VideoDraft | undefined {
    return selectVideoDraftsById(state).get(id);
}

export const selectSelectedVideoDraft = (state: RootState): string | null =>
    selectVideoPlannerState(state).selectedVideoDraft;
